import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { LogType, ObjectDebuggerService } from "blu-utilities";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { generatePostmanTestScripts, getHeadersObject } from "../utils/debug";

@Injectable()
export class ResponseLoggerInterceptor implements HttpInterceptor {
  private readonly objectDebuggerService = inject(ObjectDebuggerService);

  private request!: HttpRequest<any>;

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.request = request;
    const clonedRequest = request.clone();

    return next.handle(clonedRequest).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.logResponseDetails(event);
        }
      }),
    );
  }

  private logResponseDetails(response: HttpResponse<any>): void {
    this.objectDebuggerService.logObject({
      logType: LogType.RESPONSE,
      message: `${this.request?.method} - ${response.url}`, // Use the stored request
      object: {
        url: response.url,
        status: response.status,
        statusText: response.statusText,
        headers: getHeadersObject(response.headers),
        body: response.body,
        testScript: generatePostmanTestScripts(response, this.request),
      },
    });
  }
}
